import { SELECTED_CICLO_CHANGED } from '../actions/ciclo-entrega.actions'

const initialSystemState = {
  selectedCiclo: {
    cicloId: null,
    cicloName: '',
    empresaId: null,
    empresaDeId: null,
    file_type_id: '',
  },
}

export default function (state = initialSystemState, action) {
  switch (action.type) {
    case SELECTED_CICLO_CHANGED:
      const { cicloId, empresaId, empresaDeId, cicloName, file_type_id, operationcenter_id } =
        action.payload
      return {
        ...state,
        selectedCiclo: {
          cicloId,
          empresaId,
          empresaDeId,
          cicloName,
          file_type_id,
          operationcenter_id,
        },
      }
    default:
      return state
  }
}
